// @flow

import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";
import { toastr } from "react-redux-toastr";
import styles from "./issueType.scss";
import InputField from "../../../../commons/formElements/inputField/inputField";
import { createIssueSubmit } from "../categorySettingsRedux/categorySettingsActionCreator";
import { isNullOrEmptyString } from "../../../../../services/helpers";
import { getEntityTypes } from "../../createTicket/createTicketRedux/createTicketActionCreator";

type Props = {
  onBack: Function,
  ticketTypeDTO?: Object,
  createIssueSubmit: Function,
  categorySettingsState: Object,
  groupType: Object,
  userProfile: Object,
  getEntityTypes: Function,
  createTicketState: Object
};

type State = {
  name: string,
  primaryInfo: string,
  minimumSeverity: string,
  maximumSeverity: string,
  escalationMatrix: Object,
  isActive: string,
  ticketFieldType: string
};

const severityOptions = [
  { value: "ONE", label: "ONE" },
  { value: "TWO", label: "TWO" },
  { value: "THREE", label: "THREE" },
  { value: "FOUR", label: "FOUR" },
  { value: "FIVE", label: "FIVE" }
];

const ticketFieldTypeOptions = [
  { value: "INTERNAL", label: "INTERNAL" },
  { value: "EXTERNAL", label: "EXTERNAL" }
];

const isActiveOptions = [
  { value: "ACTIVE", label: "ACTIVE" },
  { value: "INACTIVE", label: "INACTIVE" }
];

const serviceLevelAgreementMap = {
  LEVEL_ONE: {
    hours: null,
    minutes: null,
    hoursError: false,
    minutesError: false
  },
  LEVEL_TWO: {
    hours: null,
    minutes: null,
    hoursError: false,
    minutesError: false
  },
  LEVEL_THREE: {
    hours: null,
    minutes: null,
    hoursError: false,
    minutesError: false
  },
  LEVEL_FOUR: {
    hours: null,
    minutes: null,
    hoursError: false,
    minutesError: false
  },
  LEVEL_FIVE: {
    hours: null,
    minutes: null,
    hoursError: false,
    minutesError: false
  }
};

class IssueType extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    const { ticketTypeDTO } = this.props;
    this.state = {
      name: ticketTypeDTO ? ticketTypeDTO.name : "",
      primaryInfo: ticketTypeDTO ? ticketTypeDTO.entityType : "NONE",
      minimumSeverity: ticketTypeDTO ? ticketTypeDTO.minimumSeverity : "ONE",
      maximumSeverity: ticketTypeDTO ? ticketTypeDTO.maximumSeverity : "FIVE",
      escalationMatrix: ticketTypeDTO
        ? this.millisToEscalationMatrix(ticketTypeDTO.slaList)
        : Object.assign({}, serviceLevelAgreementMap),
      isActive: this.getIsActive(ticketTypeDTO),
      ticketFieldType: ticketTypeDTO
        ? ticketTypeDTO.ticketFieldType
        : "INTERNAL"
    };
  }

  componentDidMount() {
    this.props.getEntityTypes();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.categorySettingsState.issue.isLoading &&
      nextProps.categorySettingsState.issue.isLoaded &&
      nextProps.categorySettingsState.issue.data
    ) {
      if (this.props.ticketTypeDTO) {
        toastr.success("Issue type edited successfully");
      } else {
        toastr.success("Issue type created successfully");
      }
      this.props.onBack();
    }
  }

  onSubmit() {
    if (isNullOrEmptyString(this.state.name)) {
      toastr.error("Please enter issue name");
      return;
    }
    if (isNullOrEmptyString(this.state.primaryInfo)) {
      toastr.error("Please enter primaryInfo");
      return;
    }
    if (isNullOrEmptyString(this.state.minimumSeverity)) {
      toastr.error("Please enter minimum severity");
      return;
    }
    if (isNullOrEmptyString(this.state.maximumSeverity)) {
      toastr.error("Please enter maximum severity");
      return;
    }
    if (isNullOrEmptyString(this.state.ticketFieldType)) {
      toastr.error("Please enter access type");
      return;
    }
    if (isNullOrEmptyString(this.state.isActive)) {
      toastr.error("Please enter status");
      return;
    }
    let escalationError = false;
    const escalationMatrix = Object.assign({}, this.state.escalationMatrix);
    Object.keys(serviceLevelAgreementMap).forEach(level => {
      if (isNullOrEmptyString(this.state.escalationMatrix[level].hours)) {
        this.state.escalationMatrix[level] = Object.assign(
          this.state.escalationMatrix[level],
          { hoursError: true }
        );
        escalationError = true;
      }
      if (isNullOrEmptyString(this.state.escalationMatrix[level].minutes)) {
        this.state.escalationMatrix[level] = Object.assign(
          this.state.escalationMatrix[level],
          { minutesError: true }
        );
        escalationError = true;
      }
    });
    if (escalationError) {
      this.setState({ escalationMatrix }, () => {
        toastr.error("Please enter escalation times correctly");
      });
      return;
    }
    const formData = {
      businessUnitId: this.props.userProfile.business_unit.id,
      groupTypeId: this.props.groupType.id,
      id: this.props.ticketTypeDTO ? this.props.ticketTypeDTO.id : null,
      name: this.state.name,
      isActive: this.state.isActive !== "INACTIVE",
      ticketFieldType: this.state.ticketFieldType,
      entityType: this.state.primaryInfo,
      autoClosureTrigger: this.props.ticketTypeDTO
        ? this.props.ticketTypeDTO.autoClosureTrigger
        : null,
      autoAssignSuggestion: this.props.ticketTypeDTO
        ? this.props.ticketTypeDTO.autoAssignSuggestion
        : null,
      autoClosable: this.props.ticketTypeDTO
        ? this.props.ticketTypeDTO.autoClosable
        : null,
      createRenderId: this.props.ticketTypeDTO
        ? this.props.ticketTypeDTO.createRenderId
        : null,
      createRenderMetadata: this.props.ticketTypeDTO
        ? this.props.ticketTypeDTO.createRenderMetadata
        : null,
      viewRenderId: this.props.ticketTypeDTO
        ? this.props.ticketTypeDTO.viewRenderId
        : null,
      viewRenderMetadata: this.props.ticketTypeDTO
        ? this.props.ticketTypeDTO.viewRenderMetadata
        : null,
      businessUnitDTO: this.props.ticketTypeDTO
        ? this.props.ticketTypeDTO.businessUnitDTO
        : null,
      maximumSeverity: this.state.maximumSeverity,
      minimumSeverity: this.state.minimumSeverity,
      slaList: this.props.ticketTypeDTO
        ? this.getEscalation(this.props.ticketTypeDTO.slaList)
        : this.getEscalation()
    };
    this.props.createIssueSubmit(formData, this.props.ticketTypeDTO);
  }

  getEntityTypeOptions() {
    const arr = this.props.createTicketState.entityTypes.data || [];
    return arr.map(option => ({
      value: option.key,
      label: option.val
    }));
  }

  getEscalation(slaList) {
    if (slaList) {
      slaList.forEach(option => {
        option.solvingTime = this.getMillis(
          this.state.escalationMatrix[option.escalationLevel].hours,
          this.state.escalationMatrix[option.escalationLevel].minutes
        );
      });
      return slaList;
    }
    const listToReturn = Object.keys(serviceLevelAgreementMap).map(level => ({
      escalationLevel: level,
      solvingTime: this.getMillis(
        this.state.escalationMatrix[level].hours,
        this.state.escalationMatrix[level].minutes
      )
    }));
    return listToReturn;
  }

  getIsActive(ticketTypeDTO) {
    if (ticketTypeDTO && !ticketTypeDTO.isActive) {
      return "INACTIVE";
    }
    return "ACTIVE";
  }

  getMillis(hours, minutes) {
    return (60 * Number(hours) + Number(minutes)) * 60000;
  }

  changeEscalationState(val, level, type) {
    const currentEscalation = this.state.escalationMatrix;
    currentEscalation[level] =
      type === "hours"
        ? { hours: val, minutes: currentEscalation[level].minutes }
        : { hours: currentEscalation[level].hours, minutes: val };
    this.setState({
      escalationMatrix: currentEscalation
    });
  }

  millisToEscalationMatrix(slaList) {
    const escalationMatrix = Object.assign({}, serviceLevelAgreementMap);
    if (slaList) {
      slaList.forEach(option => {
        let timeDiff = option.solvingTime / 1000;
        const hours = Math.floor(timeDiff / 3600);
        timeDiff -= hours * 3600;
        const minutes = Math.floor(timeDiff / 60) % 60;
        escalationMatrix[option.escalationLevel] = { hours, minutes };
      });
    }
    return escalationMatrix;
  }

  handleBack() {
    this.props.onBack();
  }

  renderEscalationForm() {
    return (
      <div className={`${styles.escalationTable}`}>
        {Object.keys(serviceLevelAgreementMap).map(level => (
          <div key={level} className={`${styles.utilityBar} l-row a-center`}>
            <div className="flex-40">
              <h3>{level.replace("_", " ")}</h3>
            </div>
            <div className={`${styles.escalationInput} flex-30`}>
              <InputField
                onChange={newValue => {
                  this.changeEscalationState(newValue, level, "hours");
                }}
                type="number"
                value={this.state.escalationMatrix[level].hours}
                placeholder="Hrs"
                inputFieldWrapperClass={
                  this.state.escalationMatrix[level].hoursError
                    ? "input-error"
                    : null
                }
              />
            </div>
            <div className={`${styles.escalationInput} flex-30`}>
              <InputField
                onChange={newValue => {
                  this.changeEscalationState(newValue, level, "minutes");
                }}
                value={this.state.escalationMatrix[level].minutes}
                type="number"
                placeholder="Mins"
                inputFieldWrapperClass={
                  this.state.escalationMatrix[level].minutesError
                    ? "input-error"
                    : null
                }
              />
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderLeftForm() {
    return (
      <div>
        <div className={`${styles.utilityBar}`}>
          <h2>Name of issue type</h2>
        </div>
        <div className={`${styles.utilityBar}`}>
          <InputField
            onChange={text => {
              this.setState({
                name: text
              });
            }}
            value={this.state.name}
          />
        </div>
        <div className={`${styles.utilityBar}`}>
          <h2>Primary extra information needed*</h2>
        </div>
        <div className={`${styles.select}`}>
          <Select
            onBlurResetsInput={false}
            onSelectResetsInput={false}
            options={this.getEntityTypeOptions()}
            simpleValue
            clearable={false}
            name="selected-state"
            disabled={false}
            value={this.state.primaryInfo}
            onChange={newValue =>
              this.setState({
                primaryInfo: newValue
              })
            }
            placeholder="For eg CN number"
            searchable={true}
          />
        </div>
        <div className={`${styles.utilityBar}`}>
          <h2>Minimum Severity*</h2>
        </div>
        <div className={`${styles.select}`}>
          <Select
            onBlurResetsInput={false}
            onSelectResetsInput={false}
            options={severityOptions}
            simpleValue
            clearable={false}
            name="selected-state"
            disabled={false}
            value={this.state.minimumSeverity}
            onChange={newValue =>
              this.setState({
                minimumSeverity: newValue
              })
            }
            searchable={true}
          />
        </div>
        <div className={`${styles.utilityBar}`}>
          <h2>Maximum Severity*</h2>
        </div>
        <div className={`${styles.select}`}>
          <Select
            onBlurResetsInput={false}
            onSelectResetsInput={false}
            options={severityOptions}
            simpleValue
            clearable={false}
            name="selected-state"
            disabled={false}
            value={this.state.maximumSeverity}
            onChange={newValue =>
              this.setState({
                maximumSeverity: newValue
              })
            }
            searchable={true}
          />
        </div>
        <div className={`${styles.utilityBar}`}>
          <h2>Access type*</h2>
        </div>
        <div className={`${styles.select}`}>
          <Select
            onBlurResetsInput={false}
            onSelectResetsInput={false}
            options={ticketFieldTypeOptions}
            simpleValue
            clearable={false}
            name="selected-state"
            disabled={false}
            value={this.state.ticketFieldType}
            onChange={newValue =>
              this.setState({
                ticketFieldType: newValue
              })
            }
            searchable={true}
          />
        </div>
        <div className={`${styles.utilityBar}`}>
          <h2>Status*</h2>
        </div>
        <div className={`${styles.select}`}>
          <Select
            onBlurResetsInput={false}
            onSelectResetsInput={false}
            options={isActiveOptions}
            simpleValue
            clearable={false}
            name="selected-state"
            disabled={false}
            value={this.state.isActive}
            onChange={newValue =>
              this.setState({
                isActive: newValue
              })
            }
            searchable={true}
          />
        </div>
      </div>
    );
  }

  renderRightForm() {
    return (
      <div>
        <div className={`${styles.utilityBar} ${styles.heading}`}>
          <h2>Time for escalations*</h2>
        </div>
        <div
          className={`${styles.utilityBar} ${styles.escalationBox} j-center`}
        >
          {this.renderEscalationForm()}
        </div>
        {this.renderSubmitButton()}
      </div>
    );
  }

  renderSubmitButton() {
    return (
      <div>
        <div className={`${styles.buttonGroup} l-row`}>
          <div
            className={`${styles.btnBackWrapper} l-row a-center`}
            onClick={() => this.handleBack()}
          >
            <div>
              <div className={`${styles.btnBackTextWrapper} j-center a-center`}>
                Back
              </div>
            </div>
          </div>
          <div
            className={`${styles.btnWrapper} l-row a-center`}
            onClick={() => this.onSubmit()}
          >
            <div>
              <div className={`${styles.btnTextWrapper} j-center a-center`}>
                Submit
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={`${styles.initialUtilityBar}`}>
        <div className={`${styles.utilityBar}`}>
          <h1>Add new issue type</h1>
        </div>
        <div className="l-row">
          <div className={`${styles.pane}`}>{this.renderLeftForm()}</div>
          <div>{this.renderRightForm()}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  categorySettingsState: state.categorySettingsState,
  userProfile: state.userProfile,
  createTicketState: state.createTicketState
});

const mapDispatchToProps = dispatch => ({
  createIssueSubmit: bindActionCreators(createIssueSubmit, dispatch),
  getEntityTypes: bindActionCreators(getEntityTypes, dispatch)
});

IssueType.defaultProps = {
  ticketTypeDTO: null
};

export default connect(mapStateToProps, mapDispatchToProps)(IssueType);



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/categorySettings/issueType/issueType.js